import React, { useState, useEffect, useRef } from "react";

const ArtistInfoOverlay = ({ activeArt, setInfoIsVisible, artistInfoHeaderRef, artistInfoHeaderButtonRef }) => {
    const [isVisible, setIsVisible] = useState(false);
    const [isClickOutside, setIsClickOutside] = useState(false);

    const overlayContentRef = useRef(null);
    const overlayDropdownRef = useRef(null);

    const handleClickOutside = (event) => {
        if (
            overlayContentRef.current &&
            !overlayContentRef.current.contains(event.target) &&
            artistInfoHeaderRef.current && 
            !artistInfoHeaderRef.current.contains(event.target) ||
            event.target === artistInfoHeaderButtonRef.current ||
            artistInfoHeaderButtonRef.current.contains(event.target)
        ) {
            setIsClickOutside(true);
        }
    };

    const slideUp = () => {
        if (!overlayDropdownRef.current) return;
        overlayDropdownRef.current.style.height = "0px";
    };

    const slideDown = () => {
        if (!overlayDropdownRef.current) return;
        overlayDropdownRef.current.style.height = "auto";
        var height = overlayDropdownRef.current.clientHeight + "px";
        overlayDropdownRef.current.style.height = "0px";
        setTimeout(() => {
            overlayDropdownRef.current.style.height = height;
        }, 20);
    };

    useEffect(() => {
        if (isClickOutside && isVisible) {
            slideUp();
            setIsVisible(false);
            setIsClickOutside(false);
            setTimeout(() => {
                setInfoIsVisible(false);
            }, 400);
        }

        document.addEventListener("mousedown", handleClickOutside, true);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside, true);
        };
    }, [isClickOutside]);

    useEffect(() => {
        slideDown();
        setIsVisible(true);
    }, []);

    return (
        <div
            className={`absolute bg-black-o-80 w-full h-screen top-112 left-0 z-40 fade-bg${
                isVisible ? " fade-bg-in" : ""
            }`}
        >
            <div ref={overlayDropdownRef} className="slide" style={{height: '0px'}}>
                <div
                    className="bg-gray-brown-x-light px-16 pt-24 pb-40 border-t-1 border-gray-brown"
                    ref={overlayContentRef}
                >
                    <p className="text-14 text-center">
                        {activeArt.description}
                    </p>
                    <div className="mt-28 text-center">
                            <a
                                href={activeArt.authorSocialMediaUrl}
                                target="_blank"
                                className="link link--primary link--arrow-right outline-none focus:shadow-outline focus:rounded"
                            >
                                <span>{activeArt.authorSocialMediaText}</span>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 18.02 8.82"
                                >
                                    <path
                                        xmlns="http://www.w3.org/2000/svg"
                                        d="M13.86.29a1,1,0,0,0-1.41,0,1,1,0,0,0,0,1.41l1.71,1.7H1a1,1,0,0,0,0,2H14.16l-1.71,1.7a1,1,0,0,0,0,1.41,1,1,0,0,0,.71.3,1,1,0,0,0,.7-.29L18,4.41Z"
                                    ></path>
                                </svg>
                            </a>
                       
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ArtistInfoOverlay;